<template>
  <div>
    <div class="header_index_nav">
      <header>
        <div class="index_nav_white top">
          <div class="nav_box">
            <div class="nav_flex">
              <div class="nav_logo_b"></div>
              <div class="nav_li">
                <div class="nav_li_text" @click="headerClick('aboutus')">关于我们</div>
                <div class="nav_li_text" @click="headerClick('society')">社会责任</div>
                <div class="nav_li_text" @click="headerClick('news')">新闻动态</div>
                <div class="nav_li_text" @click="headerClick('InvestorRelations')">投资者关系</div>
                <div class="nav_li_text" @click="headerClick('joinUs')">加入我们</div>
              </div>
              <i class="iconfont icon-website-shouye index_m"></i>
            </div>
          </div>
        </div>
      </header>
    </div>
    <main class="index_main_content">
      <div class="news_content_box">
        <div class="recruit_layout">
          <div class="recruit_left_box">
            <div class="classify_list">
              <div class="classify_name">城市</div>
              <div class="classify_content">
                <div><label><input type="checkbox" v-model="groupModel.city.北京" @change="changeSearch">北京</label></div>
                <div><label><input type="checkbox" v-model="groupModel.city.武汉" @change="changeSearch">武汉</label></div>
                <div><label><input type="checkbox" v-model="groupModel.city.珠海" @change="changeSearch">珠海</label></div>
                <div><label><input type="checkbox" v-model="groupModel.city.成都" @change="changeSearch">成都</label></div>
              </div>
            </div>
            <div class="classify_list">
              <div class="classify_name">公司</div>
              <div class="classify_content">
                <div><label><input type="checkbox" v-model="groupModel.company.集团平台" @change="changeSearch">集团平台</label></div>
                <div><label><input type="checkbox" v-model="groupModel.company.金山世游" @change="changeSearch">金山世游</label></div>
              </div>
            </div>
            <div class="classify_list">
              <div class="classify_name">职位类别</div>
              <div class="classify_content">
                <div><label><input type="checkbox" v-model="groupModel.positionTypeDevelop" @change="changeSearch">研发</label></div>
                <div><label><input type="checkbox" v-model="groupModel.positionTypeProduct" @change="changeSearch">产品</label></div>
                <div><label><input type="checkbox" v-model="groupModel.positionTypeDesign" @change="changeSearch">设计</label></div>
                <div><label><input type="checkbox" v-model="groupModel.positionTypeOperate" @change="changeSearch">运营</label></div>
                <div><label><input type="checkbox" v-model="groupModel.positionTypeMarket" @change="changeSearch">市场</label></div>
                <div><label><input type="checkbox" v-model="groupModel.positionTypePlaform" @change="changeSearch">平台</label></div>
                <div><label><input type="checkbox" v-model="groupModel.positionTypeFunction" @change="changeSearch">职能</label></div>
              </div>
            </div>
          </div>
          <div class="recruit_right_box">
            <div class="position_title">职位列表<span>{{' （发现 ' + recruitData.list.length + ' 个职位）'}}</span></div>
            <div class="position_list_content" v-if="recruitData.list.length > 0">
              <div class="position_list" v-for="item,index in recruitData.list" :key="index" @click="toDetailPage(item.id)" >
                <div class="position_name">{{item.title}}</div>
                <div class="position_tag">
                  <div>{{item.city}}</div>
                  <div>{{getPositionName(item.positionTypeDesign,item.positionTypeDevelop,item.positionTypeOperate,item.positionTypeProduct,item.positionTypeMarket,item.positionTypePlaform,item.positionTypeFunction)}}</div>
                  <div>{{item.jobType}}</div>
                  <div>{{item.source}}</div>
                </div>
              </div>
            </div>
            <div class="position_list_content_nocontent" v-else>
              <span>还没有发布相关的职位</span>
            </div>
          </div>
        </div>
        
      </div>

    </main>
    <footer-build @gotoBody="gotoBody"></footer-build>
    
    
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import UtilEvent from '../utils/UtilEvent'
  export default {
    name: 'RecruitList',
    data(){
      return{
        positionType:[
          {
            key:'positionTypeDesign',
            name:'设计',
          },
          {
            key:'positionTypeDevelop',
            name:'研发',
          },
          {
            key:'positionTypeOperate',
            name:'运营',
          },
          {
            key:'positionTypeProduct',
            name:'产品',
          },
          {
            key:'positionTypeMarket',
            name:'市场',
          },
          {
            key:'positionTypePlaform',
            name:'平台',
          },
          {
            key:'positionTypeFunction',
            name:'职能',
          },
          
        ],
        recruitData:{
          total:0,
          list:[]
        },
        recruitDataSource:{
          total:0,
          list:[]
        },
        conditions:[
          
        ],
        groupModel:{
          city:{
            北京:false,
            武汉:false,
            珠海:false,
            成都:false
          },
          company:{
            集团:false,
            金山世游:false
          },
          positionTypeDesign:false,
          positionTypeDevelop:false,
          positionTypeProduct:false,
          positionTypeOperate:false,
          positionTypeMarket:false,
          positionTypePlaform:false,
          positionTypeFunction:false
        }
      }
    },
    methods:{
      ...mapActions("global", ["ActionSetCurrentTap"]),
      gotoBody(){
        this.$refs.parentDiv.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      },
      changeSearch(){
        let arrayCompany = this.combinConditions(this.groupModel.company);
        let arrayCity = this.combinConditions(this.groupModel.city);
        let arrayPosition = []
        if(this.groupModel.positionTypeDesign){
          arrayPosition.push("positionTypeDesign");
        }
        if(this.groupModel.positionTypeDevelop){
          arrayPosition.push("positionTypeDevelop");
        }
        if(this.groupModel.positionTypeOperate){
          arrayPosition.push("positionTypeOperate");
        }
        if(this.groupModel.positionTypeProduct){
          arrayPosition.push("positionTypeProduct");
        }
        if(this.groupModel.positionTypeMarket){
          arrayPosition.push("positionTypeMarket");
        }
        if(this.groupModel.positionTypePlaform){
          arrayPosition.push("positionTypePlaform");
        }
        if(this.groupModel.positionTypeFunction){
          arrayPosition.push("positionTypeFunction");
        }
        let items = this.searchItems(this.recruitDataSource.list, arrayCompany,arrayCity,arrayPosition);
        this.$set(this.recruitData,"list",items);
        this.$set(this.recruitData,"total",items.length);
      },
      combinConditions(object){
        let arrayItem = [];
        for(let key in object){
          if(object[key]){
            arrayItem.push(key);
          }
        }
        return arrayItem;
      },
      searchItems(items,arrayCompany,arrayCity,arrayPosition) {
        return items.filter(item => {
          let isExistCompany = true;
          let isExistCity = true;
          let isExistPosition = true;
          if(arrayCompany && arrayCompany.length > 0){
            for(let i = 0 ;i < arrayCompany.length;i ++){ 
              if(item.company == arrayCompany[i]){
                isExistCompany = true;
                break;
              }
              if( i  == arrayCompany.length - 1){
                isExistCompany = false
              }
            }
            
          }
          if(arrayCity && arrayCity.length > 0){
            for(let j = 0 ;j < arrayCity.length;j ++){ 
              if(item.city == arrayCity[j]){
                isExistCity = true;
                break;
              }
              if( j  == arrayCity.length - 1){
                isExistCity = false
              }
            }
            
          }
          if(arrayPosition && arrayPosition.length > 0){
            for(let k = 0 ;k < arrayPosition.length;k ++){ 
              if(item[arrayPosition[k]]){
                isExistPosition = true;
                break;
              }
              if( k  == arrayPosition.length - 1){
                isExistCity = false
              }
            }
            
          }
          return isExistCompany && isExistCity && isExistPosition;
        });
      },
      toMain(){
        // this.ActionSetCurrentTap('');
        this.$router.push({name:'main'})
      },
      headerClick(pageName){
        this.ActionSetCurrentTap(pageName);
        this.$router.push(pageName);
      },
      getPositionName(...params){
        let result = "";
        for(let i = 0;i < params.length;i++){
          if(params[i]){
            result = result + this.positionType[i].name + "  " ;
          }
        }
        return result;
      } ,
      getRecruitList(){
        new UtilEvent().getRecruitList(this);
      },
      toDetailPage(messageId){
        // this.$router.push({name:'newsDetail', query: {detailId:messageId}});
        // window.open({name:'newsDetail', query: {detailId:messageId}});
        let url = this.$router.resolve({
          name: "recruitDetail",
          query: {detailId:messageId}
        });
        this.$PageUtil.openNewPage(this,url.href)
        
      },
     
    },
    mounted(){
      this.getRecruitList();
    }
  }
  </script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

